(()=>{
  const SB='https://ouhtkmpgsmauyebwpqsj.supabase.co';
  const KEY='sb_publishable_CBwe_LRkZmEii18EiiUtuA_uxonULzb';
  const originalFetch=window.fetch.bind(window);

  function root(){return document.getElementById('cvAddPlace');}
  function msg(text,kind='err'){const r=root();if(!r)return;const m=r.querySelector('#cvaddMsg');if(m){m.className=kind;m.textContent=text;}}
  function autoName(){const r=root();if(!r)return;const input=r.querySelector('#cvaddName');if(!input||input.value.trim())return;const preview=(r.querySelector('#cvaddPreview')?.textContent||'').replace('Punto seleccionado','').trim();input.value=preview&&preview.length<120?preview:'Lugar compartido por la comunidad';}

  document.addEventListener('click',e=>{
    const b=e.target.closest('#cvaddSubmit');
    if(!b)return;
    const r=root();if(!r)return;
    autoName();
    const type=r.querySelector('[data-type].on');
    if(!type){
      e.preventDefault();e.stopImmediatePropagation();
      msg('Antes de enviar, elige si es un área, camping, parking, picnic, servicio u otro lugar.');
      const step2=r.querySelector('[data-step="2"]');
      r.querySelectorAll('.cvadd-step').forEach(x=>x.hidden=x!==step2);
      r.querySelectorAll('.cvadd-steps b').forEach((x,i)=>x.classList.toggle('on',i===1));
      r.querySelector('.cvadd-box')?.scrollTo({top:0,behavior:'smooth'});
      return;
    }
    msg('Enviando tu aportación…','');
  },true);

  window.fetch=async function(input,init={}){
    const url=typeof input==='string'?input:(input?.url||'');
    const method=(init.method||'GET').toUpperCase();

    if(url.includes('/rest/v1/community_spot_submissions?select=id')&&method==='POST'){
      try{
        const payload=JSON.parse(init.body||'{}');
        if(!payload.name||!String(payload.name).trim())payload.name='Lugar compartido por la comunidad';
        const rpc=await originalFetch(SB+'/rest/v1/rpc/community_submit_place',{
          method:'POST',
          headers:{apikey:KEY,Authorization:'Bearer '+KEY,'Content-Type':'application/json'},
          body:JSON.stringify({p_payload:payload})
        });
        if(!rpc.ok)return rpc;
        const id=await rpc.json();
        return new Response(JSON.stringify([{id}]),{status:200,headers:{'Content-Type':'application/json'}});
      }catch(err){
        return new Response(JSON.stringify({message:'No se pudo guardar la aportación'}),{status:500,headers:{'Content-Type':'application/json'}});
      }
    }

    if(url.includes('/rest/v1/community_spot_submissions?id=eq.')&&method==='PATCH'){
      try{
        const id=decodeURIComponent(url.split('id=eq.')[1].split('&')[0]);
        const body=JSON.parse(init.body||'{}');
        const rpc=await originalFetch(SB+'/rest/v1/rpc/community_attach_photos',{
          method:'POST',
          headers:{apikey:KEY,Authorization:'Bearer '+KEY,'Content-Type':'application/json'},
          body:JSON.stringify({p_id:id,p_photos:Array.isArray(body.photos)?body.photos:[]})
        });
        return rpc;
      }catch(err){
        return new Response('{}',{status:200,headers:{'Content-Type':'application/json'}});
      }
    }

    return originalFetch(input,init);
  };
})();